export default {"src":"/_next/static/media/fast-company-logo.61b4e342.svg","height":28,"width":101,"blurWidth":0,"blurHeight":0};